import React from "react";

const GenericActionButtons = ({
  viewProjectLink,
  fillOfferLink,
  expressionOfInterestLink = "https://www.optiven.co.ke/expression-of-interest/",
  showRestrictedActions = true,
}) => {
  const handleViewProjectClick = () => {
    if (viewProjectLink) window.location.href = viewProjectLink;
  };
  const handleFillOfferClick = () => {
    if (fillOfferLink) window.location.href = fillOfferLink;
  };
  const handleEoIClick = () => {
    if (expressionOfInterestLink)
      window.location.href = expressionOfInterestLink;
  };

  return (
    <div
      className="card bg-purple-300 shadow-xl"
      style={{ display: "flex", flexDirection: "column", flex: 1 }}
    >
      <div
        className="card-body"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          flex: 1,
        }}
      >
        <h2 className="card-title">Action Buttons</h2>
        {showRestrictedActions && (
          <>
            <button
              className="btn btn-outline btn-accent"
              onClick={handleEoIClick}
              style={{ flex: 1 }}
            >
              Expression of Interest
            </button>
            <button
              className="btn btn-outline btn-secondary"
              onClick={handleFillOfferClick}
              style={{ flex: 1 }}
              disabled={!fillOfferLink}
            >
              Fill Offer Letter
            </button>
          </>
        )}
        <button
          className="btn btn-outline btn-primary"
          onClick={handleViewProjectClick}
          style={{ flex: 1 }}
          disabled={!viewProjectLink}
        >
          View Project
        </button>
      </div>
    </div>
  );
};

export default GenericActionButtons;
